import Vue from 'vue';
//
// This store is just for handling the generall socket events. Pls put the individual socket events in the store they belong to
//
export const state = {
  connect: false,
  socketId: null,
  jobIds: new Set(),
  connectionNotificationShown: false,
};

export const getters = {
  getSocketId: (state) => {
    const { socketId } = state;
    state.jobIds.add(socketId);
    return socketId;
  },
  isValidJobId: state => jobId => state.jobIds.has(jobId),
};

export const mutations = {
  SOCKET_CONNECT: (state) => {
    state.connect = true;
  },
  SOCKET_ID: (state, id) => {
    state.socketId = id;
  },
  SOCKET_DISCONNECT(state) {
    state.connect = false;
  },
  SET_CONNECTION_NOTIFICATION_SHOWN(state, value) {
    state.connectionNotificationShown = value;
  },
};

export const actions = {

  onConnected({ commit }, socket) {
    commit('SOCKET_CONNECT');
    commit('SOCKET_ID', socket.id);
  },
  onDisconnected({ commit }) {
    commit('SOCKET_DISCONNECT');
    commit('SOCKET_ID', null);
  },
  isValidJobId({ getters }, jobId) {
    return getters.isValidJobId(jobId);
  },
  async getSocketId({ state, commit }) {
    if (state.connect && state.socketId) {
      state.jobIds.add(state.socketId);
      return state.socketId;
    }

    const socket = Vue.prototype.$socket;
    if (socket) socket.connect();

    const socketId = await new Promise((resolve) => {
      let interval;

      const timeout = setTimeout(() => {
        clearInterval(interval);
        resolve(null);
      }, 5000);

      interval = setInterval(() => {
        if (state.connect && state.socketId) {
          clearTimeout(timeout);
          clearInterval(interval);
          resolve(state.socketId);
        }
      }, 100);
    });

    if (socketId) {
      commit('SET_CONNECTION_NOTIFICATION_SHOWN', false);
      state.jobIds.add(state.socketId);
      return state.socketId;
    }

    if (!state.connectionNotificationShown) {
      commit('SET_CONNECTION_NOTIFICATION_SHOWN', true);

      Vue.prototype.$q.notify({
        message: 'Verbindung unterbrochen!',
        detail: 'Bitte laden Sie die Seite neu.',
        type: 'info',
        position: 'bottom-left',
        timeout: 0,
        actions: [
          {
            icon: 'refresh',
            handler: () => {
              window.location.reload();
            },
          },
        ],
      });
    }

    return null;
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
